import React from 'react';
import VisibilitySensor from "react-visibility-sensor";
import cell31 from "../../../assets/images/home/cell-3/1.svg";
import cell32 from "../../../assets/images/home/cell-3/2.png";

let thisComponent;

class Services extends React.Component {
	constructor(props) {
	  super(props);
	  this.state = {
		  isVisible: null
	  };
	};

	componentWillMount() {
		thisComponent = this;
	}

	onVisibilityChange(isVisible) {
		if (isVisible) { // Solamente cambia visibilidad a TRUE
			thisComponent.setState({isVisible})
		}
	}

	render() {
		const { id } = this.props;
		
		return (
			<VisibilitySensor
				onChange={this.onVisibilityChange}
			>
				<section id={id} className={`services ${this.state.isVisible ? "-visible" : "-hidden"}`}>
					<div className="services__wrapper container">
						<div className="row">
							<div className="services__cell col">
								<img src={cell31} alt="" className="services__cell__image services__cell__image--1"/>
								<img src={cell32} alt="" className="services__cell__image services__cell__image--2"/>
							</div>
							<div className="col">
								<h2 className="subtitle">Servicios</h2>
								<h3 className="title">Trabajamos diariamente en el procesamiento de múltiples tipos de estudios.</h3>
								<p className="text">Para un mejor servicio le recomendamos confirmar los requisitos de su cobertura médica y la preparación para sus análisis.</p>
							</div>
						</div>
					</div>
				</section>
			</VisibilitySensor>
		)
	}
};

export default Services;
